import { observer } from 'mobx-react-lite';
import React from 'react';
import { getAlertTableSetupComponent } from '../../../../../../classes/factories/componentFactories';
import { useAlertsStore } from '../../../../../../stores/websocketStore/_alertsStore';
import style from './AlertWatchlistComponentTableRow.module.css';
import { Direction } from './watchlistRowComponents/Direction';
import { DistanceToTrigger } from './watchlistRowComponents/DistanceToTrigger';
import { FilterStatus } from './watchlistRowComponents/FilterStatus';
import { FTFCFilter } from './watchlistRowComponents/FTFCFilter';
import { Last } from './watchlistRowComponents/Last';
import { Repeating } from './watchlistRowComponents/Repeating';
import { Setup } from './watchlistRowComponents/Setup';
import { Symbol } from './watchlistRowComponents/Symbol';

export const AlertWatchlistComponentTableRow = observer(
  ({ alertId, selectedAlert, setSelectedAlert }) => {
    const alertStore = useAlertsStore();
    const alert = alertStore.alertTradePlansById[alertId] ?? null;
    if (!alert) return null;
    const setup = alert.setup;
    const sortingDetails = alertStore.alertSortingStore[alertId] ?? null;
    const setupDetails = sortingDetails?.setupDetails ?? null;
    const SetupComponent = getAlertTableSetupComponent(setup);
    let isDeactivated = false;
    if (
      alert.restartSystemOncePositionHasFlattened &&
      alert.restartSettings.deactivateOnRestart &&
      alert.restartSettings.deactivated
    )
      isDeactivated = true;
    return (
      <tr
        className={
          selectedAlert === alertId ? style.selectedContainer : isDeactivated ? style.deactivated : style.container
        }
        onClick={() => setSelectedAlert(alertId)}
      >
        <Symbol alert={alert} />
        <Direction alert={alert} />
        <Setup alert={alert} />
        {setupDetails ? <SetupComponent details={setupDetails} /> : <td></td>}
        <DistanceToTrigger alert={alert} alertId={alertId} />
        <Last alert={alert} />
        <FilterStatus alertId={alertId} />
        <FTFCFilter alertId={alertId} />
        <Repeating alert={alert} />
      </tr>
    );
  }
);
